import React, { Component, PropTypes } from 'react';
import InputMoment from 'input-moment';
import moment from 'moment';
import programs from 'programs';
import { firebase } from '../../../appConfig';
import '../../../node_modules/input-moment/dist/input-moment.css';
import { languages } from 'helpers/i18n'
import "./sessionPanel.scss";

const validContractIdRegEx = /^800/;

export default class SessionPanel extends Component {

  static propTypes = {
    session: PropTypes.object.isRequired,
    userId: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    approveSession: PropTypes.func,
    hideSession: PropTypes.func,
    clearFound: PropTypes.func,
    changeUser: PropTypes.func,
    cancelFundedSpot: PropTypes.func,
    refundSession: PropTypes.func,
    changeContractId: PropTypes.func,
    changeValidUntil: PropTypes.func,
    unarchiveSession: PropTypes.func,
    addToNurtureCampaign: PropTypes.func,
    putOnHold: PropTypes.func,
    changeProgram: PropTypes.func
  };

  static contextTypes = {
    userId: PropTypes.string.isRequired,
    i18n: PropTypes.func.isRequired
  };

  constructor (props) {
    super(props);
    this.state = {
      error: null,
      validUntil: moment(props.session.validUntil),
      showValidUntilPicker: false,
      programId: props.session.programId,
      showProgramSelector: false
    };
  }

  componentWillReceiveProps(props) {
    this.setState({validUntil: moment(props.session.validUntil)});
  }

  _approve (evt, noEmail) {
    const {
      userId,
      email,
      session: {
        sessionId,
        programId,
        divisionName,
        grade,
        numberOfStudents,
        language
      },
      approveSession
    } = this.props;
    const { userId: staffUserId } = this.context;
    const contractId = this.refs.contractId.value;
    evt.preventDefault();
    evt.stopPropagation();
    evt.nativeEvent.stopPropagation();
    if (!contractId) {
      this.setState({ error: 'Contract # is required!' });
      return;
    }
    if (!validContractIdRegEx.test(contractId)) {
      this.setState({ error: 'Contract # must start with 800!' });
      return;
    }
    approveSession({
      sessionId,
      contractId,
      staffUserId,
      userId,
      email,
      programId,
      grade,
      divisionName,
      numberOfStudents,
      noEmail,
      language
    });
  }

  approve (evt) {
    this._approve(evt, false);
  }

  approveWithNoEmail (evt) {
    this._approve(evt, true);
  }

  putOnHold (evt) {
    evt.preventDefault();
    evt.stopPropagation();
    const {session: {sessionId}} = this.props;
    this.props.putOnHold({sessionId});
  }

  _hide (evt, noEmail) {
    const {
      userId,
      email,
      session: {
        sessionId,
        programId,
        grade,
        divisionName,
        numberOfStudents
      },
      hideSession
    } = this.props;
    const { userId: staffUserId } = this.context;
    evt.preventDefault();
    evt.stopPropagation();
    evt.nativeEvent.stopPropagation();
    hideSession({
      sessionId,
      staffUserId,
      userId,
      email,
      programId,
      grade,
      divisionName,
      numberOfStudents,
      noEmail
    });
  }

  hide (evt) {
    this._hide(evt, false);
  }

  hideWithNoEmail (evt) {
    this._hide(evt, true);
  }

  changeUser (evt) {
    evt.preventDefault();
    evt.stopPropagation();
    const {
      userId: oldUserId,
      session: {
        sessionId,
        programId
      }
    } = this.props;
    const newUserId = this.refs.userId.value;
    const { userId: staffUserId } = this.context;
    this.props
        .changeUser({
          sessionId,
          programId,
          oldUserId,
          newUserId,
          staffUserId
        })
        .catch(err => {
          this.setState({error: err.message});
        });
  }

  backToSearch (evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.props.clearFound();
  }

  cancelFundedSpot (evt) {
    evt.preventDefault();
    evt.stopPropagation();
    const {
      session: {
        sessionId,
        programId,
        userId
      }
    } = this.props;
    const { userId: staffUserId } = this.context;
    this.props.cancelFundedSpot({sessionId, programId, userId, staffUserId});
  }

  refundSession (evt) {
    evt.preventDefault();
    evt.stopPropagation();
    const {
      session: {
        sessionId,
        programId,
        funding: sessionFunding,
        userId
      }
    } = this.props;
    const { userId: staffUserId } = this.context;
    this.props.refundSession({sessionId, sessionFunding, programId, userId, staffUserId});
  }

  unarchiveSession (evt) {
    evt.preventDefault();
    evt.stopPropagation();
    const {
      session: {
        sessionId,
        programId,
        userId
      }
    } = this.props;
    const { userId: staffUserId } = this.context;
    this.props.unarchiveSession({sessionId, programId, userId, staffUserId});
  }

  changeContractId (evt) {
    evt.preventDefault();
    evt.stopPropagation();
    const {
        session: {
            sessionId,
            programId,
            userId,
            contractId: oldContractId
        }
    } = this.props;
    const { userId: staffUserId } = this.context;
    const newContractId = this.refs.contractId.value;
    if (!newContractId) {
      this.setState({ error: 'New contract # is required!' });
      return;
    }
    if (!validContractIdRegEx.test(newContractId)) {
      this.setState({ error: 'Contract # must start with 800!' });
      return;
    }
    this.props.changeContractId({sessionId, programId, userId, staffUserId, oldContractId, newContractId});
  }

  updateValidUntil() {
    const {
      session: {
        sessionId,
        programId,
        userId,
        validUntil: oldValidUntil
      }
    } = this.props;
    const { userId: staffUserId } = this.context;
    const newValidUntil = this.state.validUntil.valueOf();
    this.props.changeValidUntil({sessionId, programId, userId, staffUserId, oldValidUntil, newValidUntil});
  }

  addToNurtureCampaign(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    const {
      session: {
        sessionId,
        userId,
        programId
      }
    } = this.props;
    const { userId: staffUserId } = this.context;
    this.props.addToNurtureCampaign({userId, sessionId, programId, staffUserId});
  }

  handleValidUntilChange(validUntil) {
    this.setState({validUntil: validUntil});
  }

  toggleValidUntilPicker(evt) {
    evt.preventDefault();
    const {
      session: {
        validUntil
      }
    } = this.props;
    this.setState({showValidUntilPicker: !this.state.showValidUntilPicker, validUntil: moment(validUntil)});
  }

  showChangeProgram(evt) {
    evt.preventDefault();
    this.setState({showProgramSelector: true});
  }

  changeProgram(evt) {
    evt.preventDefault();
    const {
      session: {
        sessionId,
        programId: oldProgramId,
        userId
      }
    } = this.props;
    this.props.changeProgram({sessionId, oldProgramId, newProgramId: this.state.programId, userId});
    this.setState({showProgramSelector: false});
  }

  render () {
    const {
      session: {
        sessionId,
        createdAt,
        funding,
        programId,
        divisionName,
        grade,
        numberOfStudents,
        contractId,
        validUntil,
        archived,
        archivedAt,
        onHold,
        language
      }
    } = this.props;
    const { i18n: _ } = this.context;
    const isApproval = this.props.approveSession && this.props.hideSession;
    const isAdmin = this.props.changeUser && this.props.clearFound;
    const program = programs.programLookup[programId];
    const { title } = program;
    const { error } = this.state;
    const firebaseBase = `https://${firebase}.firebaseio.com`;
    const firebaseLink = `${firebaseBase}/sessions/${sessionId}`;
    return (
      <form className="panel panel-default form-horizontal session-panel">
        <div className="panel-heading">
          <h4 className="panel-title">Date Started:&nbsp;{createdAt && moment(createdAt).local().toString()}</h4>
        </div>
        <div className="panel-body">
          <div className="row">
            <dl className="dl-horizontal col-xs-12 col-sm-6">
              <dt>
                Program
              </dt>
              {this.state.showProgramSelector
                ? <dd>
                  <select defaultValue={programId} value={this.state.programId} onChange={evt => this.setState({programId: evt.target.value})}>
                    {programs.programList.map(p => <option key={p.id} value={p.id}>{_(p.title)}</option>)}
                  </select>
                  <span onClick={::this.changeProgram}>{'💾'}</span>
                </dd>
                : <dd>
                  {_(title)}
                </dd>
              }
              <dt>Language</dt>
              <dd>{languages[language]}</dd>
              <dt>
                Division
              </dt>
              <dd>
                {divisionName}
              </dd>
              <dt>
                Grade
              </dt>
              <dd>
                {grade}
              </dd>
              <dt>
                Students
              </dt>
              <dd>
                {numberOfStudents}
              </dd>
              <dt>
                Session ID
              </dt>
              <dd>
                <a href={firebaseLink} target="_blank">{sessionId}</a>
              </dd>
              {isAdmin &&
              <dt>
                Funding
              </dt>
              }
              {isAdmin &&
              <dd>
                {funding}
              </dd>
              }
              {isAdmin &&
              <dt>
                Contract ID
              </dt>
              }
              {isAdmin &&
              <dd>
                {contractId}
              </dd>
              }
              {isAdmin &&
              <dt>
                Archived
              </dt>
              }
              {isAdmin &&
              <dd>
                {archived && archivedAt && moment(archivedAt).local().toString()}
              </dd>
              }
              {isAdmin &&
              <dt>
                Valid Until
              </dt>
              }
              {isAdmin &&
              <dd>
                {validUntil && moment(this.state.validUntil).local().toString()}
                {this.state.showValidUntilPicker &&
                <InputMoment
                  moment={this.state.validUntil}
                  onChange={::this.handleValidUntilChange}
                  onSave={::this.updateValidUntil}
                  prevMonthIcon="glyphicon glyphicon-chevron-left"
                  nextMonthIcon="glyphicon glyphicon-chevron-right"/>
                }
              </dd>
              }
              <dt>Session created</dt>
              <dd>{moment(createdAt).local().toString()}</dd>
            </dl>
            {isApproval &&
            <div className="col-xs-12 col-sm-6">
              <div className="col-xs-12 col-md-6 form-group">
                <label className="control-label">
                  Contract #
                </label>
                <input
                    className="form-control"
                    ref="contractId"/>
                {error &&
                <div className="text-danger">{error}</div>
                }
              </div>
              <div className="col-xs-12 col-md-6">
                <button
                  className="btn btn-xs btn-primary approval-buttons"
                  onClick={::this.approve}>
                Approve
                </button>
                <button
                  className="btn btn-xs btn-primary approval-buttons"
                  onClick={::this.approveWithNoEmail}>
                Approve No Emails
                </button>
                {!onHold && <button
                  className="btn btn-xs btn-primary approval-buttons"
                  onClick={::this.putOnHold}>
                  Put on hold
                </button>
                }
                <button
                  className="btn btn-xs btn-primary approval-buttons"
                  onClick={::this.showChangeProgram}>
                  Change program
                </button>
                <button
                    className="btn btn-xs btn-danger approval-buttons"
                    onClick={::this.hide}>
                  {`Reject + Hide`}
                </button>
                <button
                    className="btn btn-xs btn-danger approval-buttons"
                    onClick={::this.hideWithNoEmail}>
                  {`Reject + Hide No Emails`}
                </button>
              </div>
            </div>
            }
            {isAdmin &&
            <div className="col-xs-12 col-sm-6">
              <div className="col-xs-12 col-md-6 form-group">
                <label className="control-label">
                  New User ID
                </label>
                <input
                    className="form-control"
                    ref="userId"/>
                {(!funding || contractId) &&
                <label className="control-label">
                  New Contract ID
                </label>
                }
                {(!funding || contractId) &&
                <input
                  className="form-control"
                  ref="contractId"/>
                }
                {error &&
                <div className="text-danger">{error}</div>
                }
              </div>
              <div className="col-xs-12 col-md-6 staff-actions-btn">
                <button
                    className="btn btn-xs btn-primary pull-right"
                    onClick={::this.changeUser}>
                  Reassign to new User ID
                </button>
                <button
                  className="btn btn-xs btn-primary pull-right"
                  onClick={::this.showChangeProgram}>
                  Change program
                </button>
                {!funding &&
                <button
                  className="btn btn-xs btn-primary pull-right"
                  onClick={::this.approve}>
                  Approve
                </button>
                }
                {contractId &&
                <button
                    className="btn btn-xs btn-primary pull-right"
                    onClick={::this.changeContractId}>
                  Change to new Contract ID
                </button>
                }
                {validUntil &&
                <button
                  className="btn btn-xs btn-primary pull-right"
                  onClick={::this.toggleValidUntilPicker}>
                  Change Valid Until Date
                </button>
                }
                {contractId &&
                <button
                    className="btn btn-xs btn-primary pull-right"
                    onClick={::this.cancelFundedSpot}>
                  Cancel Funded Spot
                </button>
                }
                {contractId &&
                <button
                    className="btn btn-xs btn-primary pull-right"
                    onClick={::this.addToNurtureCampaign}>
                  Add to nurture campaign
                </button>
                }
                {funding && funding.toUpperCase() === 'STRIPE' &&
                <button
                    className="btn btn-xs btn-primary pull-right"
                    onClick={::this.refundSession}>
                  Mark as Refunded
                </button>
                }
                {archived && archivedAt &&
                <button
                  className="btn btn-xs btn-primary pull-right"
                  onClick={::this.unarchiveSession}>
                  Unarchive
                </button>
                }
                <button
                    className="btn btn-xs btn-danger pull-right"
                    onClick={::this.backToSearch}>
                  {`Back to search`}
                </button>
              </div>
            </div>
            }
          </div>
        </div>
      </form>
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/staff/sessionPanel.jsx